<template>
  <div id="app">
    <v-app>
      <v-content class>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-content>
      <spinner></spinner>
      <Snackbar></Snackbar>
    </v-app>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    Spinner: () => import('@/components/custom-components/BlockSpinner'),
    Snackbar: () => import('@/components/custom-components/snackbar/snackbar.vue')
  },
  data () {
    return {
      leftNav: true,
      rightNav: false
    }
  },
  methods: {},
  computed: {
    ...mapGetters({
      vg_user: 'auth/user'
    }),
    isLoggedIn () {
      let user = this.vg_user
      if (!user || user === undefined || user === '') {
        return false
      }
      return true
    },
    displayNavs () {
      return this.isLoggedIn && !this.isLoginRoute
    },
    isLoginRoute () {
      return this.$route.name === 'Login'
    }
  }
}
</script>
